export default "__VITE_ASSET__Cxza7Tb2__"